






















































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'TableMenu',
})
export default class extends Vue {
  @Prop({}) public userActive
  @Prop({}) public mostViewContent
  public fieldsUserActive: any = [
    { key: 'no' },
    { key: 'dealerCode' },
    { key: 'dealerName' },
    { key: 'dealerCity' },
    { key: 'dealerGroup' },
    { key: 'totalAccess' },
  ]
  public fieldsCategoryMaterials: any = [
    { key: 'no' },
    { key: 'title' },
    { key: 'categoryMaterial' },
    { key: 'totalVisit' },
    { key: 'totalUser' },
  ]
}
